module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "oak.8c356bee.svg";